import { useEffect, useState } from "react";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import {
  BlogDetailWrapper,
  BlogHero,
  BlogTitle,
  BlogMeta,
  AuthorAvatar,
  BlogCover,
  BlogContent,
  RelatedWrapper,
  RelatedTitle,
  RelatedGrid,
  RelatedCard,
  RelatedThumb,
  RelatedContent,
  RelatedPostTitle,
  RelatedMeta,
  RelatedPostDesc,
} from "../../style/blogDetail.style";
import { useParams, useNavigate } from "react-router-dom";
import BlogService from "../../services/api/blog.service";
import { toast } from "../../utils/notify";
import moment from "moment";
import { envConfig } from "../../config/env.config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { Box } from "@mui/material";
import { ECommonBlogSeo, ESeoResponse } from "../../models/seo";
import SeoService from "../../services/api/seo.service";
import { Helmet } from "react-helmet-async";
import FAQ from "../../components/FAQ";
import { useTranslation } from "react-i18next";
import { IVisitRequest } from "../../models/visit";
import VisitService from "../../services/api/visit.service";

export default function BlogDetail() {
  const { slug } = useParams<{ slug: string }>();
  const [blog, setBlog] = useState<EBlogResponse | null>(null);
  const [blogRelated, setBlogRelated] = useState<EBlogResponse[]>([]);
  const [commonBlogSeo, setCommonBlogSeo] = useState<ESeoResponse>();
  const { t, i18n } = useTranslation();
  const [pageSize, setPageSize] = useState(8);
  const [avatar, setAvatar] = useState<string>();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;

    const createVisit = async () => {
      const data: IVisitRequest = {
        page: slug,
        userAgent: navigator.userAgent,
      };

      await VisitService.create(data);
    };

    const fetchBlog = async () => {
      setLoading(true);
      debugger;
      const res = await BlogService.getSingleBySlug(slug, i18n.language);

      if (res.success) {
        res.data.blog.content = res.data.blog.content.replace(/&nbsp;/g, " ");

        if (res.data.blog.avatar) {
          const urlAvatar = envConfig.MEDIA_ENDPOINT + res.data.blog.avatar;
          setAvatar(urlAvatar);
        }

        setBlog(res.data.blog);
        res.data.seo && setCommonBlogSeo(res.data.seo);
      } else {
        toast(t("blog.notFound"), "error");
      }

      setLoading(false);
    };

    fetchBlog();

    const fetchBlogRelated = async () => {
      setLoading(true);
      const data: IBlogGetPage = {
        CurrentPage: 1,
        PageSize: pageSize,
        KeySearch: "",
      };
      const res = await BlogService.userGetPage(data);

      if (res.success) {
        setBlogRelated(res.items);
      } else {
        toast(t("blog.notFound"), "error");
      }
    };

    fetchBlogRelated();

    createVisit();
  }, [slug, i18n.language]);

  // const getDataSeo = async (langParam?: string) => {
  //   if (blog) {
  //     if (blog.id) {
  //       const lang = (langParam ?? i18n.language)?.toUpperCase();
  //       const mapLang = lang === "VI" ? "VI" : "EN";
  //       const res = await SeoService.getCommonBlogSeo(blog.id, mapLang);

  //       if (res.success) {
  //         res.data && setCommonBlogSeo(res.data);
  //       }
  //     }
  //   }
  // };

  // useEffect(() => {
  //   debugger;
  //   getDataSeo(i18n.language);
  // }, [blog, i18n.language]);

  if (loading) return <div>{t("common.loading")}</div>;
  if (!blog) return <div>{t("common.noData")}</div>;
  return (
    <>
      <Helmet>
        {/* ===== BASIC SEO ===== */}
        <title>{blog?.title ?? "Dịch tài liệu online | MikoTech 2"}</title>

        <meta
          name="description"
          content={
            blog.description ??
            "Dịch tài liệu online nhanh, chính xác, bảo mật. Hỗ trợ PDF, Word, Excel, PPT, hình ảnh."
          }
        />

        <meta
          name="keywords"
          content={
            commonBlogSeo?.keywords ??
            "dịch tài liệu, dịch file pdf, dịch tiếng anh"
          }
        />

        <link rel="icon" href="/logo/logodocme.svg" />
        <meta name="author" content={commonBlogSeo?.author} />
        {/* <meta name="robots" content="index, follow" /> */}
        <meta
          name="robots"
          content={
            commonBlogSeo?.noIndex ? "noindex, nofollow" : "index, follow"
          }
        />
        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href={
            commonBlogSeo?.canonical
              ? commonBlogSeo?.canonical
              : "https://docme.vn/" + blog?.slug
          }
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta property="og:type" content={commonBlogSeo?.og_type} />
        <meta property="og:site_name" content={commonBlogSeo?.og_site_name} />
        <meta property="og:title" content={commonBlogSeo?.og_title} />
        <meta
          property="og:description"
          content={commonBlogSeo?.og_description}
        />
        <meta
          property="og:url"
          content={commonBlogSeo?.og_url ?? "https://docme.vn/"}
        />
        <meta property="og:image" content={commonBlogSeo?.og_image_alt} />
        <meta
          property="og:image:width"
          content={commonBlogSeo?.og_image_width}
        />
        <meta
          property="og:image:height"
          content={commonBlogSeo?.og_image_height}
        />
        <meta property="og:locale" content={commonBlogSeo?.og_locale} />

        <meta name="twitter:card" content={commonBlogSeo?.twitter_card} />
        <meta name="twitter:title" content={commonBlogSeo?.twitter_title} />
        <meta
          name="twitter:description"
          content={commonBlogSeo?.twitter_description}
        />
        <meta name="twitter:image" content={commonBlogSeo?.twitter_image} />

        {/* ===== CONTACT / BUSINESS INFO ===== */}
        {commonBlogSeo?.schema && (
          <div dangerouslySetInnerHTML={{ __html: commonBlogSeo?.schema }} />
        )}
      </Helmet>

      <BlogDetailWrapper>
        <BlogHero>
          <BlogTitle>{blog.title}</BlogTitle>

          <BlogMeta>
            <AuthorAvatar src={avatar ?? "https://i.pravatar.cc/150?img=12"} />
            <span>{blog.authorName ?? "Admin"}</span>
            <span>•</span>
            <span>{moment(blog.dateTime).format("DD/MM/YYYY")}</span>
          </BlogMeta>
        </BlogHero>

        {/* <BlogCover /> */}

        <BlogContent
          className="blog-content"
          dangerouslySetInnerHTML={{
            __html: blog.content,
          }}
        />
      </BlogDetailWrapper>

      {/* {commonBlogSeo?.faqs && commonBlogSeo?.faqs.length > 0 && (
        <FAQ faqs={commonBlogSeo?.faqs} />
      )} */}

      <RelatedWrapper>
        <RelatedTitle>{t("blog.relatedPosts")}</RelatedTitle>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={4}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000 }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}>
          {blogRelated.map((post) => (
            <SwiperSlide
              style={{
                height: "auto",
                paddingBottom: "20px",
                paddingTop: "20px",
              }}
              key={post.id}>
              <RelatedCard href={`/${post.slug}`}>
                <Box
                  sx={{
                    position: "relative",
                    paddingTop: "200px",
                    overflow: "hidden",
                  }}>
                  <RelatedThumb
                    src={envConfig.MEDIA_ENDPOINT + post.image}
                    alt={post.title}
                  />
                </Box>

                <RelatedContent>
                  <RelatedPostTitle>{post.title}</RelatedPostTitle>
                  <RelatedPostDesc>{post.description}</RelatedPostDesc>
                  <RelatedMeta>
                    <span>Admin</span>
                    <span>{moment(post.dateTime).format("DD/MM/YYYY")}</span>
                  </RelatedMeta>
                </RelatedContent>
              </RelatedCard>
            </SwiperSlide>
          ))}
        </Swiper>
      </RelatedWrapper>
    </>
  );
}
